import { useEffect, useRef, useState } from "react";
import { type Control, useController } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import GalleryIcon from "../../../Icons/GalleryIcon";
import { toast } from "react-toastify";
import _File_ from "../../../utils/_File_";

interface Props {
  name: string;
  control: Control;
  label?: string;
  placeholder?: string;
}

export default function ImageField({
  name,
  control,
  label = "Image",
  placeholder = "Drop Here to Upload and Preview",
}: Props) {
  const {
    field: { value = null, onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: "",
  });

  const [imagePreview, setImagePreview] = useState(value);

  const renderPreviewImage = (file: File) => {
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const file = files[0] as File;
    if (files.length > 0 && _File_.isImage(file)) {
      onChange(file);
      renderPreviewImage(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    const file = files[0] as File;
    if (files.length > 0 && _File_.isImage(file)) {
      onChange(file);
      renderPreviewImage(file);
    }
  };

  useEffect(() => {
    setImagePreview(value);
  }, [value]);

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      className={tw`pb-[20px] mt-2 relative`}
    >
      <label
        htmlFor={name}
        className={tw`text-[16px] font-[500] leading-[22px] text-left text-[#030303] pb-2`}
      >
        {label}
      </label>
      <label
        htmlFor={name}
        className={tw`text-[16px] font-[500] leading-[22px] text-left text-[#030303] pb-2 absolute inset-0`}
      >
        {" "}
      </label>
      <div
        className={tw`input_field w-full h-[200px] p-[20px] gap-[10px] border border-[#00000033] rounded-[4px] flex flex-col justify-center items-center cursor-pointer`}
      >
        <input
          type="file"
          className={tw`hidden`}
          accept="image/*"
          onChange={handleImageChange}
          id={name}
        />
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="Product"
            className={tw`max-h-full max-w-full`}
          />
        ) : (
          <>
            <GalleryIcon
              className={tw`w-[24px] h-[24px] text-[#CCCCCC] mb-[12px]`}
            />
            <div className={tw`text-center text-[#CCCCCC]`}>{placeholder}</div>
          </>
        )}
      </div>
      {error && (
        <div className={tw`text-red-600 text-[12px]`}>{error.message}</div>
      )}
    </div>
  );
}
